import * as XLSX from 'xlsx'
import {SavedPurchaseOrderDetail} from '../services/purchaseOrdersApi'

export function exportFinalOrderXlsx(detail: SavedPurchaseOrderDetail) {
  if (detail.order.status !== 'finalized') return

  const activeItems = detail.items.filter((item) => !item.is_removed)
  if (!activeItems.length) return

  const rows = [
    ['ATENÇÃO: Não remova o cabeçalho desta planilha (linhas 1 a 4).'],
    ['Passo 1: Insira um SKU (código de barras) por linha e a respectiva quantidade desejada.'],
    ['Passo 2: Salve o arquivo, mantenha o formato original (.xlsx) e importe na plataforma.'],
    ['SKU (código de barras)', 'Quantidade desejada'],
    ...activeItems.map((item) => [item.ean, item.final_quantity]),
  ]

  const worksheet = XLSX.utils.aoa_to_sheet(rows)
  worksheet['!cols'] = [{wch: 25}, {wch: 22}]
  worksheet['!merges'] = [
    {s: {r: 0, c: 0}, e: {r: 0, c: 1}},
    {s: {r: 1, c: 0}, e: {r: 1, c: 1}},
    {s: {r: 2, c: 0}, e: {r: 2, c: 1}},
  ]

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Pedido')
  const cnpj = detail.order.cnpj.replace(/\D/g, '')
  XLSX.writeFile(workbook, `pedido_${cnpj}_${detail.order.order_number}.xlsx`)
}
